import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configureEncryption } from '@/services/encryption/configure-encryption';
import { ConfigureEncryptionRequest } from '@/services/encryption/encryption-types';
import { ENCRYPTION_STATUS_QUERY_KEY } from '@/hooks/queries/use-get-encryption-status';

export const useConfigureEncryption = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (config: ConfigureEncryptionRequest) =>
      configureEncryption(config),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENCRYPTION_STATUS_QUERY_KEY],
      });
    },
  });
};
